import "./App.css";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import Main from "./Component/Main";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FitGuide from "./Component/FitGuide";
import ScrollToTop from "./Component/ScrollToTop";
import Faqs from "./Component/Faqs";
import Cookies from "./Component/Cookies";

function NotFound() {
  return <main className="not-found"><p className="eyebrow">404</p><h1>We couldn’t find that page.</h1><p>The link may be out of date, or the page may have moved.</p><Link className="button button--dark" to="/">Return home</Link></main>;
}

function AppLayout() {
  const location = useLocation();
  const isCheckout = location.pathname === "/checkout";

  return (
    <>
      <ScrollToTop />
      {!isCheckout && <Header />}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/shopDetails/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/cartpage" element={<CartPage />} />
        <Route path="/checkout" element={<CheckOut />} />
        <Route path="/order-success" element={<PaySuccess />} />
        <Route path="/paysuccess" element={<PaySuccess />} />
        <Route path="/payment" element={<PaySuccess />} />
        <Route path="/about" element={<About />} />
        <Route path="/fit-guide" element={<FitGuide />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shipping" element={<Delivery />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isCheckout && <Footer />}
    </>
  );
}

function App() {
  return <CartProvider><BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}><AppLayout /></BrowserRouter></CartProvider>;
}

export default App;
